import { FeatureFlags } from '@/modules/featureFlags';

import { useFeatureFlag } from './useFeatureFlag';

export const useIsLockCardPurseAvailable = (): boolean =>
  useFeatureFlag(FeatureFlags.LOCK_CARD_PURSE);
